import { deepTransformKeys } from "../../utils/transformObjectKeys";
import { snakeToCamel } from "../../utils/camelSnakeTransformation";

export class AgronomistInvoiceDto {
  static fromApi(invoice) {
    return {
      id: invoice.id,
      status: invoice.status,
      statusDisplay: invoice.statusDisplay,
      action: invoice.action,
      help: invoice.help,
      errorCode: invoice.errorCode,
      errorMessage: invoice.errorMessage,
      year: invoice.year,
      issueDate: invoice.issueDate,
      description: invoice.description,
      comments: invoice.comments,
      unitPrice: invoice.unitPrice,
      quantity: invoice.quantity,
      paymentCode: invoice.paymentCode,
      farmerEmail: invoice.farmerEmail,
      farmerPhone: invoice.farmerPhone,
      farmerName: invoice.farmerName,
      farmerTaxNumber: invoice.farmerTaxNumber,
      netAmount: invoice.netAmount,
      vatAmount: invoice.vatAmount,
      totalAmount: invoice.totalAmount,
      paymentMethod: invoice.paymentMethod,
      mark: invoice.mark,
      goDocumentCode: invoice.goDocumentCode,
    };
  }

  static listFromApi(data) {
    const invoices = Array.isArray(data) ? data : data.results;
    return invoices.map(AgronomistInvoiceDto.fromApi);
  }

  static batchFromApi(batch) {
    return {
      id: batch.id,
      status: batch.status,
      pauseReason: batch.pauseReason,
      counts: batch.counts,
      rows: batch.rows.map((row) => ({
        farmerTaxNumber: row.farmerTaxNumber,
        status: row.status,
        detail: row.detail,
        invoiceId: row.invoiceId,
        invoiceStatus: row.invoiceStatus,
        invoiceError: row.invoiceError,
        mark: row.mark,
        goDocumentCode: row.goDocumentCode,
      })),
    };
  }

  // Error bodies skip the response interceptor, so they arrive in snake_case.
  // Field errors (DRF) have no `code`/`action`; the rest always do.
  // A server crash answers with an HTML page, which carries nothing to show.
  static errorFromApi(error) {
    const data = error.response?.data;
    const isJson = data !== null && typeof data === "object";
    const body = deepTransformKeys(isJson ? data : {}, snakeToCamel);
    const { code, detail, action, help, reasons, ...fieldErrors } = body;
    return {
      status: error.response?.status,
      code,
      detail,
      action: action ?? null,
      help: help ?? null,
      reasons: reasons ?? [],
      fieldErrors: code ? {} : fieldErrors,
    };
  }
}
